<template lang="pug">
  include /mixins

  +b.sorting
    .is-disable-xl
      native-sorting(
        :values='values',
        :init-value='checked',
        @change='checked = $event; submit()'
      )
    +e.icon.mdi.mdi-chevron-down
    +e.row-xl
      .is-visible-xl(v-if='needTitle')
        +e.row
          slot(name='title')
      +e.row(v-if='needSearch')
        slot(name='search')
      .is-visible-xl
        +e.select(v-if="isselectsort")
          +e.title.P.ds-caption--size_sm.--light {{ _('Сортировать по:') }}
          ui-dropdown(:init='false')
            template(#default='{ activeState, toggleActive, hide, style: { icon } }')
              ui-click-outside(:do='hide')
                +b.t-dropdown(:class="{ 'is-active': activeState }")
                  +e.single(@click.prevent='toggleActive()')
                    +e.title.SPAN {{ currentOption ? currentOption.title : '-' }}
                    +e.icon.mdi.I(:class='icon')
                  +e.content-wrapper(v-show="activeState")
                    +e.option(
                      v-for="val in values"
                      @click='selectOption(val);hide()'
                      :class="{ 'is-active': val.key == checked }"
                    )
                      +e.SPAN.label {{ val.title }}
        +e.row(v-else)
          +e.title.P.ds-caption--size_sm.--light {{ _('Сортировать по:') }}
          +e.values
            +e.value(v-for='val in values')
              +b.variants-filter--no-pa
                +e.element.INPUT(
                  type='radio'
                  :value='val.key',
                  name='order'
                  v-model='checked'
                  :id='`${val.key}`'
                  @change='submit()'
                )
                +e.LABEL.label.ds-caption--size_sm(
                  :class='{"is-active": val.key == checked}'
                  :for='`${val.key}`'
                ) {{ val.title }}
</template>

<script>
export default {
  name: 'Sorting',
  props: [
    'disabled',
    'value',
    'filters',
    'available',
    'needTitle',
    'needSearch',
    'values',
    'isselectsort',
  ],
  data() {
    return {
      vaslues: [
        {
          title: this._('имени (А-Я)'),
          key: 'name',
        },
        {
          title: this._('имени (Я-А)'),
          key: '-name',
        },
        {
          title: this._('популярности'),
          key: '-rating',
        },
        {
          title: this._('новинки'),
          key: '-date',
        },
      ],
      checked: {},
      show: false,
    }
  },

  watch: {
    value(nval) {
      this.checked = this.normalize(nval)
    },
  },
  computed: {
    currentOption() {
      return this.values.find(el => el.key == this.checked)
    },
  },
  mounted() {
    this.checked = this.normalize(this.value)
  },
  methods: {
    selectOption(val) {
      this.checked = val.key

      this.submit()
    },
    submit() {
      this.$emit('input', [this.checked])
    },
    notAvailable(id) {
      const { length } = Object.keys(this.available)
      let answer = false
      if (length) {
        if (this.available[id]) {
          answer = false
        } else {
          answer = true
        }
      } else {
        answer = false
      }
      return answer
    },
    normalize(value) {
      if (!value) return []
      const checked = this.values.find(el => {
        if (el.key == value[0]) {
          return el
        }
      })
      return checked.key
    },
  },
}
</script>
